<template>
  <div class="correction-wrap-bg">
    <div class="correction-wrap">
      <EditInvoiceUploadForm
        ref="uploaded-invoice-edit-form"
        emit-submit
        is-edit
        @updated="invoiceUpdated"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import EditInvoiceUploadForm from "@/components/invoices/EditInvoiceUploadForm"
export default {
  name: 'EditInvoiceUploadView',
  components: {
    EditInvoiceUploadForm,
  },
  props: {

  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      invoice: 'invoices/getInvoice'
    }),
  },
  created () {
    this.$emit('display-buttons', 'create')
  },
  methods: {
    ...mapActions ({
      loadInvoice: 'invoices/loadInvoice'
    }),
    invoiceUpdated () {
      this.loadInvoice(this.invoice.id).then(() => {
        this.$router.push({ name: 'InvoiceView', params: { invoiceId: this.invoice.id } }).catch(() => {})
      })
      this.$emit('invoice-updated')
    },
    saveUploadedInvoice () {
      this.$refs['uploaded-invoice-edit-form'].onSubmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.correction-wrap-bg {
  @media (min-width: '992px') {
    background: $colorBgGrey;
    padding: 1rem;
    min-height: 100%;
    .correction-wrap {
      min-height: 100vh;
      max-width: 1200px;
      margin: 0 auto;
      border-radius: $radiusLg;
      background: white;
      box-shadow: $dropdownShadow;
      padding: 1rem;
    }
  }
}

.correction-wrap {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
}
</style>